import React, { FC } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

type Props = {
  isOpen: boolean;
};

export const LoadingSpinner: FC<Props> = ({ isOpen }) => {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isOpen} data-testid="loading-spinner">
      <CircularProgress color="inherit" size={80} />
    </Backdrop>
  );
};
